import React from 'react';
import { VehicleDetail } from '../VehicleDetail';
import { NenreisDetail } from '../NenreisDetail';
import { PurposeDetail } from '../PurposeDetail';
import { makeStyles } from '@material-ui/styles';
import { Card, CardHeader, CardContent, Grid } from '@material-ui/core';
import styles from 'styles/admin-detail.module.scss';
import { convertToJapaneseCalendar } from 'utils/japaneseCalendarConverter';
import { getStylesBackgroundColor} from 'views/Detail/components';
import { getStylesLabelColorLine} from 'views/Detail/components';

const useStyles = makeStyles(() => ({
  changeDate: { marginLeft: 10, marginBottom: 30 },
}));

const ChangePriceDetail = (props) => {
  const classes = useStyles();

  const { detailData } = props;
  return (
    <Card>
      <CardHeader
        title='自動車金銭異動'
        className={getStylesBackgroundColor(detailData.insuranceType)}
      />
      <CardContent className={styles.cardContent}>
        <div className={classes.changeDate}>
          <Grid container spacing={1}>
            <Grid item xs={3}>
              <p className={getStylesLabelColorLine(detailData.insuranceType)}>変更希望日</p>
              <p className={styles.text}>
                {convertToJapaneseCalendar(detailData.changePrice?.changeDate) || '-'}
              </p>
            </Grid>
          </Grid>
        </div>
        {/* 車両入替 */}
        {detailData.vehicle?.id && (
          <VehicleDetail
            vehicle={detailData.vehicle}
            insuranceType={detailData.insuranceType}
            lockedBy={detailData.lockedBy}
          />
        )}
        {/* 運転者限定・年齢条件 */}
        {detailData.nenrei?.id && (
          <NenreisDetail
            nenrei={detailData.nenrei}
            insuranceType={detailData.insuranceType}
          />
        )}
        {/* 使用目的変更 */}
        {detailData.purpose?.id && (
          <PurposeDetail
            purpose={detailData.purpose}
            insuranceType={detailData.insuranceType}
          />
        )}
      </CardContent>
    </Card>
  );
};

export default ChangePriceDetail;
